export default __webpack_public_path__ + "images/0x12c26138b666360ab2b7a1b149df9cf6642cdfbf.png";